"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _draftjsToHtml = _interopRequireDefault(require("draftjs-to-html"));

var _withStyles = _interopRequireDefault(require("elevate-ui/withStyles"));

var _classnames = _interopRequireDefault(require("classnames"));

var _WYSIWYGFormatting = _interopRequireDefault(require("../Common/TextEditor/WYSIWYGFormatting"));

var _stringReplace = _interopRequireDefault(require("../../utils/string-replace"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var TextPreview = function TextPreview(_ref) {
  var attrs = _ref.content.attrs,
      classes = _ref.classes,
      replacements = _ref.internals.replacements;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes.root, classes[attrs.alignment]),
    dangerouslySetInnerHTML: {
      __html: (0, _stringReplace["default"])((0, _draftjsToHtml["default"])(attrs.value), replacements)
    }
  });
};

var styles = function styles(theme) {
  return {
    root: _objectSpread(_objectSpread({
      color: function color(_ref2) {
        var attrs = _ref2.content.attrs;
        return attrs && attrs.color;
      },
      width: "100%",
      lineHeight: "1.3rem",
      textAlign: "left"
    }, _WYSIWYGFormatting["default"]), {}, {
      "& > *": {
        color: "inherit !important"
      },
      paddingTop: function paddingTop(_ref3) {
        var attrs = _ref3.content.attrs;
        return attrs.paddingTop ? "".concat(attrs.paddingTop, "px") : "0";
      },
      paddingRight: function paddingRight(_ref4) {
        var attrs = _ref4.content.attrs;
        return attrs.paddingRight ? "".concat(attrs.paddingRight, "px") : "0";
      },
      paddingBottom: function paddingBottom(_ref5) {
        var attrs = _ref5.content.attrs;
        return attrs.paddingBottom ? "".concat(attrs.paddingBottom, "px") : "0";
      },
      paddingLeft: function paddingLeft(_ref6) {
        var attrs = _ref6.content.attrs;
        return attrs.paddingLeft ? "".concat(attrs.paddingLeft, "px") : "0";
      }
    }),
    left: {
      textAlign: "left"
    },
    center: {
      textAlign: "center"
    },
    right: {
      textAlign: "right"
    }
  };
};

var _default = (0, _withStyles["default"])(styles, {
  name: "TextPreview"
})(TextPreview);

exports["default"] = _default;